export default "__VITE_ASSET__dbceb0ae__"